(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["breadcrumb"] && !Shopify.designMode) return;
  try {
    (function() {
    'use strict';
    
    const breadcrumbItem = document.querySelector('.breadcrumb__item--collection');
    if (!breadcrumbItem) return;
    
    const defaultHandle = breadcrumbItem.dataset.defaultCollectionHandle;
    const defaultTitle = breadcrumbItem.dataset.defaultCollectionTitle;
    const defaultUrl = breadcrumbItem.dataset.defaultCollectionUrl;
    const productCollections = JSON.parse(breadcrumbItem.dataset.productCollections || '[]');
    
    // Get referrer URL
    const referrer = document.referrer;
    if (!referrer) return;
    
    try {
      const referrerUrl = new URL(referrer);
      const referrerPath = referrerUrl.pathname;
      
      // Check if referrer is a collection page
      const collectionMatch = referrerPath.match(/\/collections\/([^\/\?]+)/);
      if (!collectionMatch) return;
      
      const referrerCollectionHandle = collectionMatch[1];
      
      // Check if this collection is in the product's collections
      const referrerCollection = productCollections.find(c => c.handle === referrerCollectionHandle);
      
      if (referrerCollection) {
        // Update breadcrumb to show the referrer collection
        const link = breadcrumbItem.querySelector('.breadcrumb__link--collection');
        const nameSpan = breadcrumbItem.querySelector('.breadcrumb__collection-name');
        
        if (link && nameSpan) {
          link.href = referrerCollection.url;
          nameSpan.textContent = referrerCollection.title;
        }
      }
    } catch (e) {
      // Silently fail if URL parsing fails
      console.debug('Breadcrumb referrer detection failed:', e);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
